

import { motion } from "motion/react";

export const HowItWorks = () => {
  const steps = [
    { step: "01", title: "Share Requirements", desc: "Share your hiring requirements and ideal candidate profile." },
    { step: "02", title: "Activation", desc: "QuantumHire activates sourcing + AI screening instantly." },
    { step: "03", title: "Receive Candidates", desc: "Receive qualified, pre-screened candidates continuously on your dashboard." },
    { step: "04", title: "Hire & Pay", desc: "Pay only when you successfully hire. Zero upfront risk." }
  ];

  return (
    <section id="how-it-works" className="py-40 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="mb-24">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-brand-accent font-black uppercase tracking-[0.3em] text-xs mb-6 block border-l-4 border-brand-accent pl-6">From requirement to hire — streamlined</span>
            <h2 className="text-6xl md:text-8xl font-display font-bold tracking-tight">How it works</h2>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-4 gap-16 relative">
          <div className="absolute top-[88px] left-[10%] right-[10%] h-0.5 border-t-2 border-dashed border-gray-200 hidden lg:block -z-10" />
          
          {steps.map((s, i) => (
            <motion.div 
              key={i} 
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15 }}
              className="relative group"
            >
              <div className="w-24 h-24 rounded-[2rem] bg-brand-primary text-white flex items-center justify-center font-display font-black text-3xl mb-12 shadow-2xl group-hover:scale-110 group-hover:shadow-brand-accent/50 transition-all duration-500">
                {s.step}
              </div>
              <h3 className="text-3xl font-bold mb-6 tracking-tight leading-tight">{s.title}</h3>
              <p className="text-gray-500 leading-relaxed font-bold italic opacity-70 text-lg">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
